import getClosest from '../utilities/get-closest'

function Accordion() {
	this.elements = {}

	this.activeElement = null

	this.scrollOnExpand = false

	this.scrollToItem = (element) => {
		const rect = element.getBoundingClientRect()
		const top = window.scrollY + rect.top

		window.scrollTo({
			top: top,
			left: 0,
			behavior: 'smooth',
		})
	}
	;(this.getChildIndex = (button) => {
		var child = button.closest('.accordion__item')
		var parent = child.parentNode

		return Array.prototype.indexOf.call(parent.children, child)
	}),
		(this.toggleItem = (event) => {
			const element = event.target

			const itemContainer = getClosest(element, '.accordion__item')

			// if an active item is visible, collapse it
			if (this.activeElement !== null) {
				this.activeElement.classList.remove('accordion__item--expanded')

				// if the active element was the click target, then drop the reference to the active element
				if (this.activeElement.getAttribute('data-accordion-id') === element.getAttribute('data-accordion-id')) {
					this.activeElement = null
					return true
				}
			}

			itemContainer.classList.add('accordion__item--expanded')
			this.activeElement = itemContainer

			// create and dispatch the event
			window.dispatchEvent(
				new CustomEvent('ExpandTabAccordion', {
					detail: {
						itemIndex: this.getChildIndex(element),
					},
				})
			)

			if (this.scrollOnExpand) {
				setTimeout(() => {
					this.scrollToItem(itemContainer)
				}, 250)
			}
		})

	this.cacheDom = (accordionRoot) => {
		this.elements.triggers = accordionRoot.querySelectorAll('.js-accordion-item')
	}

	this.bind = () => {
		if (this.elements.triggers) {
			this.elements.triggers.forEach((element, index) => {
				const itemContainer = getClosest(element, '.accordion__item')
				const itemId = 'accordion-item-' + index

				itemContainer.setAttribute('data-accordion-id', itemId)
				element.setAttribute('data-accordion-id', itemId)

				element.addEventListener('click', this.toggleItem, true)
			})
		}
	}

	this.destroy = (accordion) => {
		if (this.elements.triggers) {
			this.elements.triggers.forEach((element, index) => {
				const itemContainer = getClosest(element, '.accordion__item')
				itemContainer.removeAttribute('data-accordion-id')
				element.removeAttribute('data-accordion-id')
				element.removeEventListener('click', this.toggleItem, true)
			})
		}
	}

	this.init = (accordionRoot, callback) => {
		this.cacheDom(accordionRoot)
		this.bind()

		if (callback) callback()
	}
}

export default Accordion
